import { render, staticRenderFns } from "./TabelaInfosProfissionaisPf.vue?vue&type=template&id=c98e4f56&lang=pug"
import script from "./TabelaInfosProfissionaisPf.vue?vue&type=script&lang=js"
export * from "./TabelaInfosProfissionaisPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaInfosProfissionaisPf.vue?vue&type=style&index=0&id=c98e4f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports